/* eslint-disable import/no-duplicates */
import sb0 from './stacked_bill_1.png'
import sb1 from './stacked_bill_1.png'
import sb2 from './stacked_bill_2.png'
import sb3 from './stacked_bill_3.png'
import sb4 from './stacked_bill_4.png'
import sb5 from './stacked_bill_5.png'
import sb6 from './stacked_bill_6.png'
import sb7 from './stacked_bill_7.png'
import sb8 from './stacked_bill_8.png'
import sb9 from './stacked_bill_9.png'
import sb10 from './stacked_bill_10.png'
import sb11 from './stacked_bill_11.png'
import sb12 from './stacked_bill_12.png'
import sb13 from './stacked_bill_13.png'
import sb14 from './stacked_bill_14.png'
import sb15 from './stacked_bill_15.png'
import sb16 from './stacked_bill_16.png'
import sb17 from './stacked_bill_17.png'
import sb18 from './stacked_bill_18.png'
import sb19 from './stacked_bill_19.png'
import sb20 from './stacked_bill_20.png'
import sb21 from './stacked_bill_21.png'
import sb22 from './stacked_bill_22.png'

export const stackedbills = [sb0, sb1, sb2, sb3, sb4, sb5, sb6, sb7, sb8, sb9, sb10, sb11, sb12, sb13, sb14, sb15, sb16, sb17, sb18, sb19, sb20, sb21, sb22]
